<div class="tertiary-content-header">
  <h4>{{template?.title}}</h4>
</div>
<div class="pdf-logo-template">
  <div class="repair-order">
    <table>
      <thead class="report-header">
        <div class="repair-order-header">
          <!-- Company Details -->
          <div class="repair-order-company flex-start-center">
            <div class="repair-order-logo pr-3 align-self-start position-relative">
              <input (click)="pdfLogoUpload.value='';pdfLogoUpload.click();" type="file" class="d-none" [files]="null"
                (change)="handleFileUpload($event)" #pdfLogoUpload>
              <div class="personal-card-body">
                <div class="personal-card-avatar pdf-card-logo" [hidden]="!previewImage"
                  [ngClass]="{'image': previewImage}">
                  <!--
                    Classes for image
                      1 - streched
                      2- best-fit
                      3- cropped
                  -->
                  <img [src]="previewImage" [ngClass]="imageType" [alt]="_user.firstName ? _user.firstName : ''" *ngIf="previewImage">
                  <div class="personal-preview-overlay flex-center-center pointer">
                    <i class="pi pi-times text-white" (click)="clearLogo()" style="font-size: 30px;"></i>
                  </div>
                </div>
                <div class="personal-card-avatar no-pdf-logo d-flex" *ngIf="!previewImage">
                  <div class="pdf-company-logo">
                    <img [src]="company?.logo" alt="AutoLeap">
                  </div>
                  <div class="pdf-company-info">
                    <span class="font-bold font-16">{{company?.name}}</span>
                    <span>{{company?.phone | mask: '(000) 000-0000'}}</span>
                    <span>{{company?.email}}</span>
                    <span>{{company.formattedAdress}} </span>
                  </div>
                  <i class="fas fa-camera camera pointer" (click)="pdfLogoUpload.click()"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- Estimate Details -->
          <div class="repair-order-title text-left width-205">
            <p class="mb-1 order-status-title font-600">
              <span class="capitalize">Estimate # 10826</span>
            </p>
            <p class="m-0 font-16">Created: {{updatedAt | date: 'MMM d, y'}}</p>
          </div>
        </div>
      </thead>
      <tbody class="report-body">
        <tr>
          <div class="repair-order-customer">
            <div class="repair-order-left flex-column align-self-start font-14">
              <span class="font-bold">AutoLeap</span>
              <span>(647) 877-0888</span>
              <span>info@autoleap.com</span>
            </div>

            <div class="repair-order-right flex-column font-14  text-left width-205">
              <span class="font-bold">2011 Ford Fusion SE</span>
              <div class="car-info-wrapper">
                <div class="car-info-heading">VIN:</div>
                <div class="car-info-content">&nbsp;3F3FAHP0HA7BR164</div>
              </div>
              <div class="car-info-wrapper">
                <div class="car-info-heading">Mileage:</div>
                <div class="car-info-content">
                  &nbsp;65,000
                </div>
              </div>
              <div class="car-info-wrapper">
                <div class="car-info-heading">License Plate:</div>
                <div class="car-info-content">
                  &nbsp;KDU-1678
                </div>
              </div>
            </div>
          </div>
        </tr>

        <tr>
          <div class="repair-order-notes service-card">
            <div class="s-card-header">
              Brake Drum R&R (Both Sides)
            </div>

            <div class="s-card-body repair-order-service">
              <div class="s-card-row flex-start-center">
                <p class="m-0 sno"></p>
                <p class="m-0 name font-bold pr-2">Name</p>
                <p class="m-0 description font-bold">Description</p>
                <p class="m-0 price font-bold">Price</p>
                <p class="m-0 quantity font-bold">QTY/HRS</p>
                <p class="m-0 total font-bold text-right">Amount</p>
              </div>

              <div class="s-card-row flex-start-center">
                <p class="m-0 sno align-self-start">1</p>

                <p class="m-0 name align-self-start pr-2">
                  Brake Drum R&R
                </p>

                <p class="m-0 description align-self-start">
                  Includes: The removal of component and all necessary components for access. Does not include: System
                  diagnosis, testing, or a vehicle road test.
                </p>

                <p class="m-0 price align-self-start">
                  $40.00
                </p>

                <p class="m-0 quantity align-self-start">
                  0.80
                </p>
                <p class="m-0 total text-right align-self-start">
                  $32.50</p>
              </div>
            </div>
            <div class="s-card-footer flex-end-center">
              <span class="font-600 font-14 pr-3">
                Amount: $180.50</span>
              <span class="font-600 font-14 pr-3">
                Discount: $180.50
              </span>
              <span class="font-bold text-right">
                Service subtotal: $180.50
              </span>
            </div>
          </div>
        </tr>


        <tr>
          <div class="repair-order-footer flex-start-center mt-3">
            <div class="disclaimer align-self-end">
              <p class="mb-0 mr-2 pr-2 text-justify">
                Estimate I hereby authorize the above repair work to be done along with
                procurement of all necessary materials. Dev Auto Shop may operate the
                above vehicle for the purposes of testing, inspection or delivery at my
                risk. Dev Auto Shop will not be held responsible for any loss or damage
                to the vehicle or articles left in vehicle in case of re, theft, accident or
                any other cause beyond the control of Dev Auto Shop. In the event legal
                action is necessary to enforce this contract, I understand that I am solely
                responsible for all costs.

              </p>

              <div class="signature flex-start-end">
                <p class="mb-0 mt-1 mr-2">Signature:</p>
                <div class="user-sign width-100p mb-0">
                  XXXXXXX
                </div>
              </div>
            </div>

            <div class="ml-3 s-summary flex-column">
              <div class="m-0 flex-start-center mb-2">
                <p class="m-0 pr-1 s-summery-title">Part</p>
                <p class="b-bottom width-100p m-0"></p>
                <p class="m-0 summary-content text-right">$0.00</p>
              </div>

              <div class="m-0 flex-start-center mb-2">
                <p class="m-0 pr-1 s-summery-title">Labor</p>
                <p class="b-bottom width-100p m-0"></p>
                <p class="m-0 summary-content text-right">$0.00</p>
              </div>

              <div class="m-0 flex-start-center mb-2">
                <p class="m-0 pr-1 s-summery-title">Tire</p>
                <p class="b-bottom width-100p m-0"></p>
                <p class="m-0 summary-content text-right">$0.00</p>
              </div>

              <div class="m-0 flex-start-center mb-2">
                <p class="m-0 pr-1 s-summery-title"> Other</p>
                <p class="b-bottom width-100p m-0"></p>
                <p class="m-0 summary-content text-right">$0.00</p>
              </div>

              <div class="m-0 flex-start-center mb-2">
                <p class="m-0 pl-4 pr-1 s-summery-title">Amount</p>
                <p class="b-bottom width-100p m-0"></p>
                <p class="m-0 summary-content text-right">$0.00</p>
              </div>

              <div class="m-0 flex-start-center mb-2">
                <p class="m-0 pl-4 pr-1 s-summery-title">Order Discount</p>
                <p class="b-bottom width-100p m-0"></p>
                <p class="m-0 summary-content text-right">
                  $0.00
                </p>
              </div>

              <div class="m-0 flex-start-center mb-2">
                <p class="m-0 pl-4 pr-1 s-summery-title">Service&nbsp;Discount</p>
                <p class="b-bottom service-discount width-100p m-0"></p>
                <p class="m-0 summary-content text-right">
                  $0.00
                </p>
              </div>

              <div class="m-0 flex-start-center mb-2">
                <p class="m-0 pl-4 pr-1 s-summery-title">Tax</p>
                <p class="b-bottom width-100p m-0"></p>
                <p class="m-0 summary-content text-right">$0.00</p>
              </div>

              <div class="m-0 flex-start-center mb-2">
                <p class="m-0 pr-1 s-summery-title">Grand&nbsp;total</p>
                <p class="b-bottom width-100p m-0"></p>
                <p class="m-0 summary-content text-right">$0.00</p>
              </div>

              <div class="m-0 flex-start-center mb-2">
                <p class="m-0 pl-4 pr-1 s-summery-title">Paid&nbsp;to&nbsp;date</p>
                <p class="b-bottom width-100p m-0"></p>
                <p class="m-0 summary-content text-right">
                  $0.00
                </p>
              </div>

              <div class="m-0 remaining-balance flex-between-center">
                <p class="m-0 pr-1 font-15 font-bold">Remaining&nbsp;balance</p>
                <p class="m-0 width-130 text-right font-16 font-bold">
                  $0.00
                </p>
              </div>
            </div>
          </div>
        </tr>
      </tbody>
    </table>
  </div>

</div>
